import Markdown from "markdown-to-jsx";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import edjsParser from "../textEditor/htmlParser";
import Highlighter from 'react-highlight-words';

/**
 * Renders a note from a raw EditorJS block structure as markdown, with optional search-term highlighting.
 *
 * @param {Object} props
 * @param {Object} props.noteRaw - Raw EditorJS output object parsed into HTML via edjsParser.
 * @param {string|string[]} [props.query] - Search term(s) to highlight within the rendered note text; when provided, renders with Highlighter instead of markdown.
 * @returns {JSX.Element}
 */
const MarkdownNotes = ({ noteRaw, query }) => {
  const [html, setHtml] = useState("");
  useEffect(() => {
    if (!noteRaw) return;
    setHtml(edjsParser.parse(noteRaw).join(''));
  }, [noteRaw]);

  // If query is provided, use Highlighter for search highlighting
  if (query) {
    const searchWords = Array.isArray(query) ? query : [query];
    return (
      <div className="markdown-notes">
        <Highlighter
          highlightClassName="highlighted"
          searchWords={searchWords}
          autoEscape={true}
          textToHighlight={html.toString()}
        />
      </div>
    );
  }

  return (
    <Markdown options={{ wrapper: "article" }} className="markdown-notes">
      {html.toString()}
    </Markdown>
  );
};

export default MarkdownNotes;
